export default "__VITE_ASSET__D$CKPg8L__"